// extracted by mini-css-extract-plugin
export default {"value":"qizSmdFi6NAohO5h7JK_"};